/**
 * Page FAQ Gouvernance & Adhésion - FTPE Outremer
 */
import React from 'react';
import { HelpCircle } from 'lucide-react';
import BackButton from '../components/BackButton';

// Logo FTPE Outremer
const FTPE_LOGO = "https://customer-assets.emergentagent.com/job_80d9c916-7281-4428-9c84-a6e0cd256c92/artifacts/ojac2aim_logo%20ftpe%20outremer%20dans%20fond%20blanc.png";

export default function FTPEFAQPage() {
  const faqs = [
    {
      question: "Qu'est-ce que la FTPE Outremer ?",
      answer: "Syndicat patronal représentant les TPE et employeurs ultramarins."
    },
    {
      question: "Qui peut adhérer ?",
      answer: "Toute entreprise ou employeur répondant aux conditions statutaires."
    },
    {
      question: "Quel est le coût de l'adhésion ?",
      answer: "La cotisation annuelle est fixée à 200 €."
    },
    {
      question: "L'adhésion donne-t-elle accès aux dispositifs partenaires ?",
      answer: "Elle constitue un cadre institutionnel préalable, chaque dispositif restant soumis à ses propres conditions."
    },
    {
      question: "Comment fonctionne la gouvernance ?",
      answer: "Assemblée Générale, Conseil d'Administration et Bureau exécutif assurent une gouvernance démocratique et transparente."
    },
    {
      question: "Puis-je participer aux décisions ?",
      answer: "Oui, chaque adhérent dispose d'une voix en Assemblée Générale et peut se présenter aux instances."
    },
    {
      question: "Comment résilier mon adhésion ?",
      answer: "La résiliation s'effectue par courrier ou email avant l'échéance annuelle, conformément aux statuts."
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-900 via-green-900 to-slate-900 text-white py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6">
            <BackButton variant="dark" label="Retour" />
          </div>
          
          <div className="flex items-center gap-6">
            <img src={FTPE_LOGO} alt="FTPE Outremer" className="w-16 h-16 object-contain rounded-lg bg-white p-2" />
            <div>
              <h1 className="text-3xl md:text-4xl font-bold mb-2">
                FAQ – <span className="text-amber-400">Gouvernance & Adhésion</span>
              </h1>
              <p className="text-slate-300">Questions fréquentes sur la FTPE Outremer</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div className="max-w-4xl mx-auto bg-white shadow-lg -mt-8 relative z-10 rounded-2xl p-8 md:p-12 mb-12">
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-slate-200 pb-6 last:border-0">
              <h3 className="font-bold text-green-700 text-lg mb-2 flex items-start gap-3">
                <HelpCircle className="w-5 h-5 mt-1 flex-shrink-0" />
                {faq.question}
              </h3>
              <p className="text-slate-600 leading-relaxed ml-8">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-8 text-center">
        <p className="font-semibold">FTPE Outremer – Syndicat patronal ultramarin</p>
        <p className="text-slate-400 text-sm mt-2">Transparence • Responsabilité • Confiance</p>
      </footer>
    </div>
  );
}
